import React from "react";
import FAQ from "./FAQ";

const ContactUs = () => {
  return (
    <>
      <section className="min-h-screen bg-white">

        <div className="bg-black py-20 text-center px-6">
          <h2 className="text-5xl font-bold mb-4 text-white">
            Contact Us
          </h2>
          <p className="text-gray-300 max-w-2xl mx-auto">
            Have a project in mind or want to know more about our services?
            We’d love to hear from you.
          </p>
        </div>

        <div className="py-20 px-6">
          <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12">

            <div className="space-y-8">
              <div>
                <h3 className="text-3xl font-semibold mb-4 text-gray-800">
                  Let’s build something great 🚀
                </h3>
                <p className="text-gray-600">
                  Reach out to us for website development, software solutions,
                  training, or placements.
                </p>
              </div>

              <div className="space-y-6">

                <div className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-md">
                  <svg
                    className="w-6 h-6 text-indigo-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M4 4h16v16H4z" />
                    <path d="M22 6l-10 7L2 6" />
                  </svg>
                  <div>
                    <p className="text-sm text-gray-500">Email</p>
                    <p className="font-medium text-gray-800">
                      technoweit@gmail.com
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-md">
                  <svg
                    className="w-6 h-6 text-indigo-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M22 16.92V21a2 2 0 0 1-2.18 2
                      19.79 19.79 0 0 1-8.63-3.07
                      19.5 19.5 0 0 1-6-6
                      19.79 19.79 0 0 1-3.07-8.63
                      A2 2 0 0 1 3 3h4.09a2 2 0 0 1 2 1.72
                      c.12.9.32 1.77.59 2.6a2 2 0 0 1-.45 2.11L8.09 10.91
                      a16 16 0 0 0 6 6l1.48-1.48
                      a2 2 0 0 1 2.11-.45c.83.27 1.7.47 2.6.59
                      A2 2 0 0 1 22 16.92z" />
                  </svg>
                  <div>
                    <p className="text-sm text-gray-500">Phone</p>
                    <p className="font-medium text-gray-800">
                      +91 8888813277
                    </p>
                  </div>
                </div>

                <div className="flex items-center gap-4 bg-white p-5 rounded-xl shadow-md">
                  <svg
                    className="w-6 h-6 text-indigo-600"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                  >
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 1 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                  <div>
                    <p className="text-sm text-gray-500">Location</p>
                    <p className="font-medium text-gray-800">
                      Maharashtra, India
                    </p>
                  </div>
                </div>

              </div>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-xl">
              <form className="space-y-6">

                <div>
                  <label className="text-sm text-gray-600">Full Name</label>
                  <input
                    type="text"
                    className="w-full mt-2 border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 outline-none"
                    placeholder="Enter your name"
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-600">Email Address</label>
                  <input
                    type="email"
                    className="w-full mt-2 border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 outline-none"
                    placeholder="Enter your email"
                  />
                </div>

                <div>
                  <label className="text-sm text-gray-600">Message</label>
                  <textarea
                    rows="4"
                    className="w-full mt-2 border border-gray-300 rounded-lg p-3 focus:ring-2 focus:ring-indigo-500 outline-none"
                    placeholder="Write your message"
                  />
                </div>

                <button
                  type="submit"
                  className="w-full bg-black hover:bg-gray-800 transition text-white py-3 rounded-lg font-semibold"
                >
                  Send Message
                </button>

              </form>
            </div>

          </div>
        </div>
      </section>

      <FAQ />
    </>
  );
};

export default ContactUs;
